var swiper = new Swiper('.my-swiper', {
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
      });